import {Preview, template as tpl} from "./Preview";
import groupHtml from './group.html?raw';

export let template = tpl.replace('<!-- {{TEMPLATE_ROW}} -->', groupHtml);

export class viewModel extends Preview {

    constructor(params: any) {
        super(params);
        this.table = [
            {
                key: "id",
                sort: false
            },
            {
                key: "Name",
                sort: true
            },
            {
                key: "Description",
                sort: true
            },
        ];
        this.searchcolumn("Description");
    }

}
